// A4 Soft: bright game accents, readable ink, and cushioned surfaces.
// Keep these names stable for the game views and existing consumers.
export const mainColor = '#53d9f5'
export const mainColorLighter = '#e1f5fb'
export const mainColorDarker = '#087FA2'
export const mainColorLightText = '#FAFEFF'
export const mainColorDarkText = '#162f49'
export const mainColorMediumText = '#096586'
export const altColor = '#ffac78'
export const altColorLighter = '#ffefdd'
export const altColorDarker = '#E98549'
export const altColorLightText = '#FFF4E6'
export const altColorDarkText = '#944217'
export const shadow1 = '0 3px 0 #e0eaf2, 0 8px 18px rgba(28,59,87,0.04)'
export const shadow2 = '0 4px 0 #bfd4e3, 0 12px 25px rgba(24,61,86,0.07)'
export const helperTextColor = '#60768b'
export const navy = '#193b58'
export const gold = '#ffe178'
export const borderColor = '#d6e4ef'
export const canvasColor = '#f1f7fc'
export const headingFont = '"Nunito", sans-serif'
export const displayFont = '"Fredoka", "Nunito", sans-serif'
export const bodyFont = '"DM Sans", sans-serif'
export const brandBlue = '#00306d'
export const brandOrange = brandBlue
export const brandIconBlue = '#19abf6'
export const brandIconOrange = '#ff9b35'
export const brandIconBlueShadow = '#1183bf'
export const brandIconOrangeShadow = '#cd7625'
export const surfaceRadius = 28
export const panelRadius = 22
